<template>
  <v-card flat>
    <v-card-title class="subtitle-1 pa-0 ma-0">
      <span>{{ value.titulo }}</span>
      <v-switch
        v-model="value.habilitado"
        color="secondary"
        class="ml-4"
        dense
      />
    </v-card-title>
    <v-card-text
      v-show="value.habilitado"
      class="pa-0 ma-0"
    >
      <v-radio-group
        v-model="value.opcao"
        :row="value.horizontal"
        dense
      >
        <v-radio
          v-for="opcao in value.opcoes"
          :key="opcao.nome"
          :value="opcao.valor"
          :label="opcao.nome"
        />
      </v-radio-group>
      <slot name="children" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FiltroConfirm',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        titulo: '',
        habilitado: true,
        opcoes: [
          { nome: 'Sim', valor: true },
          { nome: 'Não', valor: false },
        ],
        opcao: null,
        horizontal: true,
      }),
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    'value.habilitado': function (value) {
      if (!value) {
        this.setDefault();
      }
    },
    disable(value) {
      if (value) {
        this.value.habilitado = false;
      }
    },
  },

  methods: {
    setDefault() {
      this.value.opcao = null;
    },
  },
};
</script>
